import { logInApi } from './loginApi';

export const { useSignInMutation } = logInApi;

export { logInApi };
